<template>
  <div id="page-user-list">
    <vs-card>
      <vs-button
        v-if="canAddPayroll"
        @click="popupAdd = true"
        icon-pack="feather"
        icon="icon-plus"
        color="primary"
        type="border"
        class="mb-2"
        >Adicionar desconto</vs-button
      >

      <vs-table
        search
        stripe
        :data="descontos">
        <template slot="header">
          <select
            @change="getData"
            class="block ml-3 pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
            v-validate="'excluded:1,2,3'"
            v-model="paginate"
            name="not_in_field"
            data-vv-as="selected">
            <option
              class="vs__selected-options"
              value="5">
              5
            </option>
            <option
              class="vs__selected-options"
              value="10">
              10
            </option>
            <option
              class="vs__selected-options"
              value="20">
              20
            </option>
            <option
              class="vs__selected-options"
              value="50">
              50
            </option>
            <option
              class="vs__selected-options"
              value="100">
              100
            </option>
            <option
              class="vs__selected-options"
              value="500">
              500
            </option>
            <option
              class="vs__selected-options"
              value="1000">
              1000
            </option>
          </select>
        </template>
        <template slot="thead">
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="surname">Apelido</vs-th>
          <vs-th sort-key="email">Motivo</vs-th>
          <vs-th sort-key="email">Montante</vs-th>
          <vs-th sort-key="email">Data</vs-th>
          <!-- <vs-th sort-key="email">Estado</vs-th> -->
          <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
          <vs-th></vs-th>
          <!-- <vs-th sort-key="id">Nro</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :key="indextr"
            v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>
            <vs-td :data="data[indextr].surname">
              {{ data[indextr].surname }}
            </vs-td>
            <vs-td :data="data[indextr].reason">
              {{ data[indextr].reason }}
            </vs-td>
            <vs-td :data="data[indextr].amount">
              {{ data[indextr].amount }}
            </vs-td>
            <vs-td :data="data[indextr].date">
              {{ data[indextr].date }}
            </vs-td>

            <vs-td
              class="whitespace-no-wrap"
              :data="data[indextr].id">
              <vs-row class="gap-2">
                <vs-button
                  :disabled="!canUpdatePayroll"
                  color="success"
                  size="small"
                  hover:text-danger
                  type="border"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click="popupOpenEdit(tr)">
                </vs-button>
                <vs-button
                  :disabled="!canDeletePayroll"
                  color="danger"
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="removeData(tr)"></vs-button>
              </vs-row>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>

            <!-- <vs-td :data="data[indextr].id">
        {{ data[indextr].id }}
      </vs-td> -->
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-3"
        :total="totalPage"
        @change="getEmployees"
        v-model="currentPage"></vs-pagination>
      <div
        style="height: 50px"
        id="div-with-loading"
        class="vs-con-loading__container"></div>
    </vs-card>

    <vs-popup
      class="holamundo"
      title="Actualizar Desconto"
      :active.sync="popupEdit">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label
            class="mt-8"
            for=""
            >Motivo</label
          >
          <vs-input
            class="w-full mt-2 mb-5"
            type="text"
            v-model="desconto.reason"
            v-validate="'required|alpha_spaces'" />
        </div>

        <div class="vx-col w-full mb-2">
          <label
            class="mt-8"
            for=""
            >Data</label
          >
          <vs-input
            class="w-full mt-2 mb-5"
            type="date"
            v-model="desconto.date" />
        </div>
        <div class="vx-col w-full mb-2">
          <label
            class="mt-8"
            for=""
            >Montante(Mt)</label
          >
          <vs-input
            class="w-full mt-2 mb-5"
            type="number"
            v-model="desconto.amount" />
        </div>
        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button
              class="ml-auto mt-2"
              @click="editData"
              >Actualizar</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Adicionar Desconto"
      :active.sync="popupAdd">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label
            class="mt-8"
            for=""
            >Funcionario</label
          >
          <v-select
            :label="'name'"
            class="mt-2"
            v-validate="'required'"
            v-model="selectedEmployee"
            :options="employees">
          </v-select>
        </div>
        <div class="vx-col w-full mb-2">
          <label
            class="mt-8"
            for=""
            >Motivo</label
          >
          <vs-input
            class="w-full mt-2 mb-5"
            type="text"
            v-model="reason"
            v-validate="'required'"
            name="motivo" />
          <span
            class="text-danger text-sm"
            v-show="errors.has('motivo')"
            >{{ errors.first('motivo') }}</span
          >
        </div>

        <div class="vx-col w-1/2 mb-5">
          <label for="">Ano</label> <br />

          <div class="vx-col w-full mb-5">
            <select
              v-model="dataActual"
              class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
              <option
                v-for="n in Array.from(
                  { length: 100 },
                  (v, i) => i + (new Date().getFullYear() - 99)
                )"
                :value="n"
                :key="n">
                {{ n }}
              </option>
            </select>
          </div>
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Mes</label> <br />
          <v-select
            v-validate="'required'"
            v-model="month"
            :reduce="options => options.id"
            :options="[
              { id: 1, label: 'Janeiro' },
              { id: 2, label: 'Fevereiro' },
              { id: 3, label: 'Março' },
              { id: 4, label: 'Abril' },
              { id: 5, label: 'Maio' },
              { id: 6, label: 'Junho' },
              { id: 7, label: 'Julho' },
              { id: 8, label: 'Agosto' },
              { id: 9, label: 'Setembro' },
              { id: 10, label: 'Outubro' },
              { id: 11, label: 'Novembro' },
              { id: 12, label: 'Dezembro' }
            ]">
          </v-select>
        </div>

        <div class="vx-col w-full mb-2">
          <label
            class="mt-8"
            for=""
            >Valor</label
          >
          <vs-input
            class="w-full mt-2 mb-5"
            type="number"
            v-model="amount" />
        </div>

        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button
              class="ml-auto mt-2"
              @click="saveData"
              >Salvar</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              @click="popupAdd = false"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  import vSelect from 'vue-select';
  import http from '../../../../../http-common';
  import { PermissionsMixin } from '../../../../mixins/permissions';
  // Store Module

  // Cell Renderer

  export default {
    mixins: [PermissionsMixin],
    components: {
      vSelect
    },
    data() {
      return {
        totalPage: '',
        currentPage: '1',
        paginate: 10000,
        amount: '',
        desconto: [],
        employees: [],
        popupAdd: false,
        popupEdit: false,
        name: '',
        abbreviation: '',
        type: '',
        components: [],
        component: [
          {
            id: '',
            name: '',
            abbreviation: '',
            type: ''
          }
        ],
        descontos: [],
        date: '',

        currentUser: [],
        dataActual: '',
        month: ''
      };
    },

    mounted() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.getData();
        this.getEmployees();
      },

      getEmployees() {
        //  this.$vs.loading()

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          },
          params: {
            page: this.currentPage,
            paginate: this.paginate,
            status: 1
          }
        };

        http
          .get('/employees/employees', config)
          .then(result => {
            //  this.$vs.loading.close()
            this.employees = result.data.Employees.data.reverse();
            (this.currentPage = '1'),
              (this.totalPage = result.data.Employees.last_page);
            this.total = result.data.Employees.total;
          })
          .catch(error => {
            error;
            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      },

      getData() {
        this.$vs.loading({
          container: '#div-with-loading',
          scale: 1.0,
          type: 'sound'
        });

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          },
          params: {
            paginate: this.paginate
          }
        };

        http
          .get('salaries/disconts', config)
          .then(result => {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading');
            this.descontos = result.data.Discounts.data;
            // alert("2")
          })
          .catch(error => {
            error;

            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      },

      async saveData() {
        //      this.$validator.validate('nome').then(result => {
        // if (result) {
        this.$vs.loading();

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          }
        };

        const data = {
          // 2022-06-24
          date: this.date.concat(this.dataActual, '-', this.month, '-01'),
          amount: this.amount,
          reason: this.reason,
          employee_id: this.selectedEmployee.employee_id
        };

        http
          .post('/salaries/disconts', data, config)
          .then(success => {
            success;
            (this.popupAdd = false),
              (this.amount = ''),
              (this.reason = ''),
              (this.selectedEmployee.employee_id = []),
              this.$vs.loading.close();
            this.getData(),
              this.$vs.notify({
                title: 'Sucesso',
                text: 'Desconto adicionado com sucesso!',
                color: 'success',
                position: 'top-right'
              });

            this.date = '';
            this.amount = '';
            this.reason = '';
            this.selectedEmployee = [];
          })
          .catch(error => {
            error;
            // this.err= error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Erro',
              text: this.err,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right'
            });
          });
        // }})
      },

      popupOpenEdit(desconto) {
        (this.desconto = desconto), (this.popupEdit = true);
      },

      async editData() {
        //      this.$validator.validateAll().then(result => {
        // if (result) {
        this.$vs.loading();

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          }
        };

        const data = {
          date: this.desconto.date,
          amount: this.desconto.amount,
          reason: this.desconto.reason
        };

        this.$validator.validateAll();
        http
          .put(`/salaries/disconts/${this.desconto.discount_id}`, data, config)
          .then(success => {
            success;
            (this.popupEdit = false), this.getData(), this.$vs.loading.close();
            this.$vs.notify({
              title: 'Sucesso',
              text: 'Actualizado com sucesso!',
              color: 'success',
              position: 'top-right'
            });
          })
          .catch(error => {
            error;
            this.err = error.response.data;
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Erro',
              text: this.err,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right'
            });
          });
        // }})
      },
      async removeData(desconto) {
        (this.desconto = desconto), this.$vs.loading();

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          }
        };

        this.$validator.validateAll();
        http
          .delete(`/salaries/disconts/${this.desconto.discount_id}`, config)
          .then(success => {
            success;
            (this.popupEdit = false), this.getData(), this.$vs.loading.close();
            this.$vs.notify({
              title: 'Sucesso',
              text: 'Removido com sucesso!',
              color: 'success',
              position: 'top-right'
            });
          })
          .catch(error => {
            error;
            this.err = error.response.data;
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Erro',
              text: this.err,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right'
            });
          });
        // }})
      }
    }
  };
</script>
